import { useSearchParams } from 'react-router'

import { COMPANY_PROFILE_TAB } from '@/components/misc/CompanyProfile/constants'
import { CompanyProfileTab } from '@/components/misc/CompanyProfile/types'
import { COMPANY_PROFILE_IDENTIFIER_TYPE } from '@/lib/constants'
import { SEARCH_PARAMS } from '@/lib/searchParams'

export function useCompanyProfileModal() {
  const [searchParams, setSearchParams] = useSearchParams()

  function openModal({
    companyId,
    tab,
  }: {
    companyId: number
    tab?: CompanyProfileTab
  }) {
    searchParams.set(
      SEARCH_PARAMS.companyProfile.identifierType,
      COMPANY_PROFILE_IDENTIFIER_TYPE.companyId,
    )

    searchParams.set(
      SEARCH_PARAMS.companyProfile.identifier,
      companyId.toString(),
    )

    searchParams.set(
      SEARCH_PARAMS.companyProfile.profileTab,
      tab || COMPANY_PROFILE_TAB.overview,
    )

    setSearchParams(searchParams)
  }

  function hideModal() {
    ;[
      SEARCH_PARAMS.companyProfile.identifierType,
      SEARCH_PARAMS.companyProfile.identifier,
      SEARCH_PARAMS.companyProfile.profileTab,
    ].forEach((searchParamName) => searchParams.delete(searchParamName))

    setSearchParams(searchParams)
  }

  // This function assumes the modal is already open. If it's not, this function
  // won't open the modal
  function goToTab(tab: CompanyProfileTab) {
    searchParams.set(SEARCH_PARAMS.companyProfile.profileTab, tab)
    setSearchParams(searchParams)
  }

  return {
    openModal,
    hideModal,
    goToTab,
  }
}
